export { render, renderToCanvas } from './chunk-JWY6Y6NU.mjs';

var parameters={renderer:"react"};

export { parameters };
